module.exports = __webpack_public_path__ + "img/brasao.8e58709a.png";